'use strict';

angular.module('dekky.forms.uiSelect', [])
.directive('uiSelectManualClear', function($rootScope) {
   return {
       restrict: 'A',
       require: 'uiSelect',
       link: function(scope, element, attrs, $select) {
           var syntheticEvent = {
               stopPropagation: function() {}
           };

           $rootScope.$on(attrs.uiSelectManualClear, function(event) {
               $select.clear(syntheticEvent);
               event.stopPropagation();
           });
       }
   }
});